'use client';

import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Bell, ChevronRight } from 'lucide-react';
import Profile01 from './profile-01';
import { ModeToggle } from '../mode-toggle';
import { useGetUsersMeQuery } from '@/services';
import { TenantSelector } from '../tenants/tenant-selector';
import { useState } from 'react';
import { CreateTenantDialog } from '../tenants/create-tenant-dialog';
import { NotificationsSettings } from '@/components/notifications/notification-settings';


interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function TopNav() {
  const { data } = useGetUsersMeQuery();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const breadcrumbs: BreadcrumbItem[] = [
    { label: 'Web IoT Pro', href: '#' },
    { label: 'dashboard', href: '#' },
  ];

  const user = data?.data;
  const name = user?.first_name || user?.email || 'anonymous';
  const role = user?.role;
  const avatar = undefined;
  const subscription = undefined;
  const profile = { name, role, avatar, subscription };
  const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);

  return (
    <nav className="px-3 sm:px-6 flex items-center justify-between bg-white dark:bg-[#101014] border-b border-gray-200 dark:border-[#23232a] h-full shadow-sm dark:shadow-none">
      {/* Breadcrumbs */}
      <div className="font-medium text-sm hidden sm:flex items-center space-x-1 truncate max-w-[300px]">
        {breadcrumbs.map((item, index) => (
          <div key={item.label} className="flex items-center">
            {index > 0 && <ChevronRight className="h-4 w-4 text-gray-400 dark:text-gray-500 mx-1" />}
            {item.href ? (
              <a
                href={item.href}
                className="text-gray-700 dark:text-gray-200 hover:text-primary dark:hover:text-primary transition-colors"
              >
                {item.label}
              </a>
            ) : (
              <span className="text-gray-900 dark:text-white">{item.label}</span>
            )}
          </div>
        ))}
      </div>

      {/* Tenant selector */}
      <div className="hidden md:block">
        <TenantSelector onCreateClick={() => setIsCreateDialogOpen(true)} />
      </div>

      {/* Right controls */}
      <div className="flex items-center gap-2 sm:gap-4 ml-auto sm:ml-0">
        <button
          type="button"
          className="p-1.5 sm:p-2 hover:bg-gray-100 dark:hover:bg-[#23232a] rounded-full transition-colors"
          aria-label="Notifications"
        >
          <Bell onClick={() => setIsNotificationsOpen(true)} className="h-5 w-5 text-gray-600 dark:text-gray-300" />
        </button>

        {/* <ModeToggle /> */}

        <DropdownMenu>
          <DropdownMenuTrigger className="focus:outline-none">
            <img
              src="https://ferf1mheo22r9ira.public.blob.vercel-storage.com/avatar-01-n0x8HFv8EUetf9z6ht0wScJKoTHqf8.png"
              alt="User avatar"
              width={32}
              height={32}
              className="rounded-full ring-2 ring-gray-200 dark:ring-[#23232a] sm:w-8 sm:h-8 cursor-pointer transition-shadow hover:ring-primary"
            />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            sideOffset={8}
            className="w-[280px] sm:w-80 bg-background border-border rounded-lg shadow-lg"
          >
            <Profile01
              name={profile.name}
              role={profile.role}
              avatar={profile.avatar}
              subscription={profile.subscription}
            />
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      {/* Notification Settings Modal */}
      <NotificationsSettings
        isOpen={isNotificationsOpen}
        onClose={() => setIsNotificationsOpen(false)}
        settingType='tenant'
      />

      {/* Create tenant dialog */}
      <CreateTenantDialog open={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen} />
    </nav>
  );
}
